import { render, staticRenderFns } from "./SucursalDAO.vue?vue&type=template&id=33f950b8&scoped=true&"
import script from "./SucursalDAO.vue?vue&type=script&lang=js&"
export * from "./SucursalDAO.vue?vue&type=script&lang=js&"
import style0 from "./SucursalDAO.vue?vue&type=style&index=0&id=33f950b8&scoped=true&lang=css&"
import style1 from "./SucursalDAO.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f950b8",
  null
  
)

export default component.exports